import { Style } from '../../components/VgsInput/types';
import { regExpToString } from '../../util/regExp';
import { ReplacePattern } from '../../composableComponents/VaultForm/VaultInput/types';

export const deleteEmptyFields = <ResponseData>(
  form: VGSForm<ResponseData>,
): void => {
  // delete fields that weren't loaded
  for (const field of form.fields) {
    if (field.loadingState !== 'loaded') {
      field.delete();
    }
  }
};

export const createField = <ResponseData>({
  type,
  serializers = [],
  form,
  elRef,
  name,
  placeholder,
  validations,
  style,
  maskInput,
  replacePatterns,
}: {
  type: VgsFieldType;
  serializers?: VgsSerializer[];
  form: VGSForm<ResponseData>;
  elRef: React.RefObject<HTMLDivElement>;
  name: string;
  placeholder?: string;
  validations?: RegExp[];
  style?: Style;
  maskInput?: MaskInput;
  replacePatterns?: ReplacePattern[];
}): VGSField => {
  if (type === 'file') {
    serializers.push({ name: 'toBase64' });
  }
  const field = form.field(elRef.current, {
    type,
    name,
    placeholder,
    validations: (validations || []).map(regExpToString),
    serializers,
    css: style,
  });
  if (replacePatterns) {
    for (const pattern of replacePatterns) {
      field.replacePattern(
        regExpToString(pattern.expression),
        pattern.newSubString || '',
      );
    }
  }
  if (maskInput) {
    field.mask(maskInput.mask, maskInput.maskChar, maskInput.formatChar);
  }
  return field;
};
